'use strict';

intellidealerAppPartsModule.filter('priceDifference', function ($filter) {
  return function(customerPrice, retailPrice) {
    if (customerPrice && retailPrice && (retailPrice - customerPrice > 0)) {
      return ' (' + $filter('currency')(retailPrice) + ')';
    }
    return null;
  };
});